import { Vue, Component } from 'vue-property-decorator';
import api from '@/api/module';
import { ITABLECOLCONF } from '@/types/base.d';

@Component
export default class tableMixin extends Vue {
  private tList: any = []

  private column: Array<ITABLECOLCONF> = [
    {
      label: '名称',
      prop: 'moduleTitle',
      align: 'center',
    },
    {
      label: '模块文件夹',
      prop: 'moduleFolder',
      align: 'center',
    }, {
      label: '访问路径',
      prop: 'modulePath',
      align: 'center',
    }, {
      label: '排序',
      prop: 'moduleSeq',
      align: 'center',
    }, {
      label: '创建时间',
      prop: 'createTime',
      align: 'center',
      minWidth: '100px',
      tooltip: true,
    }, {
      label: '操作',
      custom: true,
      fixed: 'right',
      btnList: [
        {
          title: '编辑',
          name: '/module/menu:remove',
          icon: 'edit',
          type: 'info',
          callback: this.rowEdit,
          log: {
            name: '模块管理 - 编辑',
            component: 'set/menu/tableMixin',
          },
        },
        {
          title: '删除',
          name: '/module/menu:remove',
          icon: 'remove',
          type: 'danger',
          callback: this.rowRemove,
          log: {
            name: '模块管理 - 删除',
            component: 'set/menu/tableMixin',
          },
        },
      ],
      prop: '',
      align: 'center',
    },
  ]

  private treeProps: any = {
    children: 'children',
  }

  private loading: boolean = true

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  rowEdit(row: any) {}

  getData() {
    this.loading = true;
    api.getModule().then((res) => {
      this.tList = res;
      this.loading = false;
    });
  }

  rowRemove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      iconType: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }).then((close: Function) => {
      api.removeModule(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '模块管理 - 删除 - 确定',
          component: 'set/menu/tableMixin',
        });
      }).catch(close());
    }).catch(() => this.$log({
      title: '模块管理 - 删除 - 取消',
      component: 'set/menu/tableMixin',
    }));
  }
}
